export default __webpack_public_path__ + "static/media/Blade's Gloves of the Hidden Tomb.8cb93530.jpg";